import React from 'react';
import SuccessScreen from '../../Common/SuccessScreen';
import disclaimerIcon from './assets/disclaimer-icon.svg';

const PaymentFailed = () => (
  <SuccessScreen
    icon={disclaimerIcon}
    title="Payment failed!"
    subtitle="Please try again or use another payment method."
  />
);

export default PaymentFailed;
